module.exports = __webpack_public_path__ + "img/gb854.prt.ff5b7224.jpg";